const bodyClass = (klass) => {
  return document.querySelector('body').classList.contains(klass);
}

export default bodyClass;